export default "__VITE_ASSET__24400c48__"